import React from "react";

const svgStyles = {
  cursor: "pointer",
};

const AddIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={12}
    fill="none"
    style={svgStyles}
    {...props}
  >
    <path
      style={svgStyles}
      fill="#3E4957"
      d="M6.5 11.25a5.25 5.25 0 1 1 0-10.5 5.25 5.25 0 0 1 0 10.5Zm0 .75a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"
    />
    <path
      style={svgStyles}
      fill="#3E4957"
      d="M6.5 3c.207 0 .375.168.375.375v2.25h2.25a.375.375 0 1 1 0 .75h-2.25v2.25a.375.375 0 1 1-.75 0v-2.25h-2.25a.375.375 0 1 1 0-.75h2.25v-2.25c0-.207.168-.375.375-.375Z"
    />
  </svg>
);
export default AddIcon;
